import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { ConfigService } from './config/config.service';

export function provideAppConfig(): EnvironmentProviders {
  return provideAppInitializer(() => inject(ConfigService).loadConfig());
}
